import { render, staticRenderFns } from "./BrProductFilter.vue?vue&type=template&id=f4ce13fe&scoped=true"
import script from "./BrProductFilter.vue?vue&type=script&lang=js"
export * from "./BrProductFilter.vue?vue&type=script&lang=js"
import style0 from "./BrProductFilter.vue?vue&type=style&index=0&id=f4ce13fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ce13fe",
  null
  
)

export default component.exports